export default __webpack_public_path__ + "static/media/OnlineEntryIcon.e6f64d31.png";